import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteDepartment as apiForceDelete } from "../../api/apiDepartments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteDepartment() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteDepartment, isPending: isForceDelete } = useMutation({
        mutationFn: (id) => apiForceDelete(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["departments"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteDepartment, isForceDelete };
}
